import React, { createContext, useEffect, useState } from 'react';

export const VideoCallContext = createContext();

export const VideoCallProvider = ({ children }) => {
  const [videoCallLaunched, setVideoCallLaunched] = useState(false);

  useEffect(()=>{
    console.log('videoCallLaunched',videoCallLaunched)
  },[videoCallLaunched])

  return (
    <VideoCallContext.Provider value={{
      videoCallLaunched,
      setVideoCallLaunched
    }}>
      {children}
    </VideoCallContext.Provider>
  );
};
